//src/pages/REG/REG920F1.jsx
import React, {useContext, useEffect, useState} from 'react';
import style from "./REG920F1.module.scss";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import {postData} from 'utils/TransactionUtil';
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import {MenuContext} from "pages/COM/COM001L1";
import Modal from "components/Modal/Modal";
import REG920F2 from "pages/RE/REG920F2";
import SelectBox from "../../components/SelectBox/SelectBox";  //상세화면

//엑셀
import * as XLSX from "xlsx"
import { saveAs } from "file-saver";
import {AuthContext} from "../../contexts/AuthContext";


// 페이지 시작
const REG920F1 = ({navBar: NavBar}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]); //기관 리스트(공통)


    const [rows_subjectList, setRows_subjectList] = useState([]);
    const cols_subjectList = [
        //{ key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'hsptNm',  name: '기관명',  width: '100px'},
        { key: 'randId',  name: '아이디',  width: '100px' },
        { key: 'randIdNm',  name: '성명',  width: '100px' },
        { key: 'randGrp', name: '랜덤그룹',    width: '100px'},
        { key: 'map01', name:  '1',  width: '100px'},
        { key: 'map02', name:  '2',  width: '100px'},
        { key: 'map03', name:  '3',  width: '100px'},
        { key: 'map04', name:  '4',  width: '100px'},
        { key: 'map05', name:  '5',  width: '100px'},
        { key: 'map06', name:  '6',  width: '100px'},
        { key: 'map07', name:  '7',  width: '100px'},
        { key: 'map08', name:  '8',  width: '100px'},
        { key: 'map09', name:  '9',  width: '100px'},
        { key: 'map10', name: '10',  width: '100px'},
        { key: 'map11', name: '11',  width: '100px'},
        { key: 'map12', name: '12',  width: '100px'},
        { key: 'map13', name: '13',  width: '100px'},
        { key: 'map14', name: '14',  width: '100px'},
        { key: 'map15', name: '15',  width: '100px'},
        { key: 'map16', name: '16',  width: '100px'},
        { key: 'map17', name: '17',  width: '100px'},
        { key: 'map18', name: '18',  width: '100px'},
        { key: 'map19', name: '19',  width: '100px'},
        { key: 'map20', name: '20',  width: '100px'},
        { key: 'map21', name: '21',  width: '100px'},
        { key: 'map22', name: '22',  width: '100px'},
        { key: 'map23', name: '23',  width: '100px'},
        { key: 'map24', name: '24',  width: '100px'},
        { key: 'map25', name: '25',  width: '100px'},
        { key: 'map26', name: '26',  width: '100px'},
        { key: 'map27', name: '27',  width: '100px'},
        { key: 'map28', name: '28',  width: '100px'},
        { key: 'map29', name: '29',  width: '100px'},
        { key: 'map30', name: '30',  width: '100px'}

    ];

    const [schRandId, setSchRandId]  = useState("");
    const [schHsptCd, setSchHsptCd]  = useState("");

    const [popRandId,  setPopRandId]  = useState("");
    const [popRandIdNm, setPopRandIdNm]  = useState("");
    const [popRandGrp, setPopRandGrp]  = useState(-1);


    //form load
    useEffect(() => {
        getComDtlsData(); //공통코드 조회
    }, []);


    /*  Event ====================================================================================================*/

    //조회 버튼 클릭
    const handleClick_search = () => {
        getRandomMappingList();
    }
    //출력 버튼 클릭
    const     handleClick_export
        = () => {
        //getRandomMappingList();
        //exportToExcel(rows_subjectList, "subject_list");
        exportToExcel(cols_subjectList, rows_subjectList, "subject_list");

    }

    const exportToExcel = (columns, rows, fileName) => {
        // 1. 헤더 정의 (컬럼의 label 값 사용)
        const header = columns.map(col => col.name);

        // 2. 데이터 변환 (각 행 데이터를 컬럼 key 기준으로 매핑)
        const data = rows.map(row => columns.map(col => row[col.key]));

        // 3. 워크북 및 워크시트 생성 (헤더 포함)
        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // 4. 엑셀 파일 생성 및 다운로드
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, `${fileName}.xlsx`);
    };




    // 데이터 더블클릭
    const handleDoubleClick_DataGrid_row = (e) => {

        setPopRandId(e.row.randId);
        setPopRandGrp(e.row.randGrp);
        setPopRandIdNm(e.row.randIdNm);
        setIsModalOpen(true);
    }

/* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setSchHsptCd(userInfo.hsptCd);
    }

    /* 데이터 조회  
    * 
    * */
    async function getRandomMappingList(){
        //메인 데이터 조회
        const param = { randId:schRandId, hsptCd:schHsptCd};

        const res = await postData("/REW/getRandomMappingList", param);
        setRows_subjectList(res);
    }

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부(사용자 상세)
    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
        getRandomMappingList();
    }
    
    return (
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "80px", height: "40px"}}
                            onClick={handleClick_search}>
                        조회
                    </Button>
                    <Button variant="Primary" size="md" addStyle={{width: "80px", height: "40px"}}
                            onClick={handleClick_export}>
                        Excel
                    </Button>

                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr>

                        <td className={style.content_typ1} style={{width: "50px"}}> 기관</td>
                        <td className={style.content_typ1} style={{width: "250px"}}>
                            <SelectBox options={comHsptObj}
                                       value={schHsptCd}
                                       onChange={(val) => setSchHsptCd(val)}
                                       width={'90%'}/>
                        </td>
                        <td className={style.content_typ1} style={{width: "50px"}}> ID</td>
                        <td className={style.content_typ1}>
                            <InputUnitText type={"text"} value={schRandId} unit={""}
                                           onChange={(value) => setSchRandId(value)}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>
            <div>

                <DataGrid
                    cols={cols_subjectList}
                    rows={rows_subjectList}
                    rowHeight={37}
                    onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                    sortable={true}
                    isNodataView={true}
                    overflowX={"auto"}
                />


            </div>
            <Modal
                open={isModalOpen}
                handle_Close={handleModal_Close}
                title="무작위군 매핑"
                width ="1100px"
                height="850px"
                isHeader={true}
                //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}
                randId={popRandId} randGrp={popRandGrp} randIdNm={popRandIdNm}
                //bottomBtnText={{cancel:"취소",confirm:"적용"}}
                //isBottom={true}
                >
                <REG920F2 handle_Close={handleModal_Close} randId={popRandId} randGrp={popRandGrp} randIdNm={popRandIdNm}/>
            </Modal>
        </main>


    )
        ;
};


export default REG920F1;
